import { QueryKeys } from "../../utils/queryKeys";

export const finalAssessmentKeys = {
  all: [QueryKeys.FINAL_ASSESSMENT_KEYS],

  getFinalAssessmentKeys: (args) => {
    const { userId } = args;

    return [...finalAssessmentKeys.all, userId];
  },
};
